import { apiLoadSettings, apiSaveSettings } from "./baseApi"

// Section name matches the AdminAjax action names exactly:
// load_weekday_capacity_settings / save_weekday_capacity_settings.
export const apiSaveWeekdayCapacitySettings = (data, callback) => {
  apiSaveSettings(data, callback, 'weekday_capacity')
}

export const apiLoadWeekdayCapacitySettings = (callback) => {
  apiLoadSettings(callback, 'weekday_capacity')
}
